export const SEO_CONTENT = {
  home: {
    title: 'Premium Handcrafted Soft Toys',
    description:
      "India's leading handcrafted soft toys brand. Discover cuddly companions made with love, premium materials, and safety tested for all ages.",
    canonical: '/',
    keywords: 'soft toys, teddy bears, stuffed animals, handcrafted toys India, BST soft toys',
  },
  shop: {
    title: 'Shop Soft Toys',
    description:
      'Browse our collection of premium handcrafted soft toys. Find the perfect cuddly companion — teddy bears, plush toys, and custom gifts.',
    canonical: '/shop',
    keywords: 'buy soft toys online, teddy bears India, plush toys shop, handcrafted teddy bears',
  },
  about: {
    title: 'About Us',
    description:
      "Learn the story behind BST - The Soft Studio. India's premium handcrafted soft toys brand, making cuddly companions with love since 2026.",
    canonical: '/about',
  },
  contact: {
    title: 'Contact Us',
    description:
      "Get in touch with BST - The Soft Studio. We'd love to hear from you. Contact us for orders, queries, or custom soft toy requests.",
    canonical: '/contact',
  },
  faq: {
    title: 'Frequently Asked Questions',
    description:
      'Find answers to common questions about ordering, shipping, returns, and products at BST - The Soft Studio.',
    canonical: '/faq',
  },
  notFound: {
    title: '404 - Page Not Found',
    description:
      'The page you are looking for does not exist. Browse our handcrafted soft toys collection at BST - The Soft Studio.',
    canonical: '/404',
  },

  cart: {
    title: 'Shopping Cart',
    descriptionEmpty:
      'Your shopping cart is empty. Start shopping for premium handcrafted soft toys at BST - The Soft Studio.',
    descriptionWithItems: (count: number) =>
      `${count} item${count === 1 ? '' : 's'} in your cart. Secure checkout for premium handcrafted soft toys.`,
    canonical: '/cart',
  },
  checkout: {
    title: 'Checkout',
    descriptionEmpty:
      'Your cart is empty. Add items to proceed with checkout at BST - The Soft Studio.',
    descriptionActive:
      'Complete your purchase at BST - The Soft Studio. Secure checkout with multiple payment options.',
    canonical: '/checkout',
  },
  wishlist: {
    title: 'My Wishlist',
    descriptionEmpty: 'Save your favorite soft toys and cuddly companions here!',
    descriptionWithItems: (count: number) =>
      `${count} item${count === 1 ? '' : 's'} saved in your wishlist at BST - The Soft Studio.`,
    canonical: '/wishlist',
  },
  search: {
    titleEmpty: 'Search Products',
    titleWithQuery: (query: string) => `Search Results for "${query}"`,
    descriptionEmpty:
      'Search for soft toys, teddy bears, and cuddly companions at BST - The Soft Studio.',
    descriptionWithQuery: (query: string) =>
      `Search results for "${query}" at BST - The Soft Studio. Find your perfect soft toy.`,
  },

  login: {
    title: 'Sign In',
    description:
      'Sign in to your BST - The Soft Studio account. Access orders, wishlist, and personalized recommendations.',
    canonical: '/login',
  },
  register: {
    title: 'Create Account',
    description:
      'Create your BST - The Soft Studio account. Save your favorites, track orders, and enjoy a personalized shopping experience.',
    canonical: '/register',
  },
  forgotPassword: {
    title: 'Forgot Password',
    description:
      'Reset your BST - The Soft Studio account password. Enter your email to receive a password reset link.',
    canonical: '/forgot-password',
    submittedTitle: 'Reset Link Sent',
    submittedDescription: 'Password reset email sent successfully.',
  },
  resetPassword: {
    title: 'Reset Password',
    description: 'Set a new password for your BST - The Soft Studio account.',
    canonical: '/reset-password',
    successTitle: 'Password Reset Success',
    successDescription:
      'Your password has been reset successfully. You can now sign in with your new password.',
    invalidTitle: 'Invalid Reset Link',
    invalidDescription: 'This password reset link is invalid or has expired.',
  },

  account: {
    title: 'My Account',
    description: (name?: string) =>
      `Welcome back${name ? `, ${name}` : ''}. Manage your BST - The Soft Studio account, view orders, and update profile.`,
    canonical: '/account',
  },

  careInstructions: {
    title: 'Care Instructions',
    description:
      'Keep your BST - The Soft Studio soft toys clean and well-maintained with our detailed care guide. Washing, drying, and storage tips.',
    canonical: '/care-instructions',
  },
  giftGuide: {
    title: 'Gift Guide',
    description:
      'Find the perfect gift for every occasion. Our curated gift guide helps you choose the right soft toy for babies, kids, and loved ones.',
    canonical: '/gift-guide',
  },
  shippingReturns: {
    title: 'Shipping & Returns',
    description:
      'Learn about shipping policies, delivery timelines, and our 30-day easy return policy at BST - The Soft Studio.',
    canonical: '/shipping-returns',
  },
  sizeGuide: {
    title: 'Size Guide',
    description:
      'Find the perfect soft toy size for your little ones. Detailed size guide for all BST - The Soft Studio products covering height, age, and use cases.',
    canonical: '/size-guide',
  },

  privacyPolicy: {
    title: 'Privacy Policy',
    description:
      'BST - The Soft Studio privacy policy. Learn how we collect, use, and protect your personal information.',
    canonical: '/privacy-policy',
  },
  termsOfService: {
    title: 'Terms of Service',
    description:
      'BST - The Soft Studio terms and conditions. Please read our terms carefully before using our website and services.',
    canonical: '/terms-conditions',
  },

  orderHistory: {
    title: 'Order History',
    description:
      'View your order history at BST - The Soft Studio. Track orders, check delivery status, and reorder your favorite items.',
    canonical: '/orders',
  },
  orderSuccess: {
    title: 'Order Placed Successfully!',
    description: (orderId: string) =>
      `Order ${orderId} placed successfully at BST - The Soft Studio. Thank you for your purchase!`,
    canonical: '/order-success',
  },

  productLoading: {
    title: 'Loading Product...',
    description: 'Loading product details from BST - The Soft Studio.',
  },
  productInvalid: {
    title: 'Invalid Product',
    description: 'The product you are looking for could not be found.',
  },
  productNotFound: {
    title: 'Product Not Found',
    description: 'The product you are looking for could not be found.',
  },
} as const;
